import script from "./AdminTextbookManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTextbookManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminTextbookManager.vue?vue&type=style&index=0&id=2c49d238&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c49d238"]])

export default __exports__